import { catchError, filter, switchMap, take } from 'rxjs'
import { fromFetch } from 'rxjs/fetch'

import { SanityImage } from '../../../groq/sanity-dispensaries/types'
import { isNotNull } from '../../../utils/collectionTools'
import { coerceCaughtToLeft } from '../../../utils/rx/errors'
import { latestAccessToken$ } from '../../auth/state'
import { fetchResponseToJsonResult, headers } from '../../fetch'

export const fromAssetCreateRequest = (body: File) =>
  latestAccessToken$.pipe(
    filter(isNotNull),
    take(1),
    switchMap((accessToken) =>
      fromFetch('/api/sanity-dispensaries/asset', {
        body,
        method: 'POST',
        headers: {
          ...headers.acceptJson,
          ...headers.authorization(accessToken),
          ...headers.contentType(body.type),
        },
      }),
    ),
    switchMap((response) => fetchResponseToJsonResult<SanityImage>(response)),
    catchError(coerceCaughtToLeft),
  )
